var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInEarNotDetected = function SvgIconInEarNotDetected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.133 8.242a2.1 2.1 0 0 1 2.105-2.1c.725 0 1.228.237 1.586.64.279.313.451.716.589 1.038l.058.134c.163.374.313.655.556.858.229.19.598.357 1.287.357 3.134 0 6.151 2.418 6.151 6.148 0 3.461-2.793 6.15-6.15 6.15h-.004c-3.452-.022-6.178-2.857-6.178-6.29zm2.105-1.1a1.1 1.1 0 0 0-1.105 1.1v6.935c0 2.9 2.298 5.27 5.183 5.29a5.134 5.134 0 0 0 5.15-5.15c0-3.117-2.507-5.148-5.152-5.148-.86 0-1.476-.213-1.928-.59-.437-.364-.663-.84-.831-1.223l-.066-.15c-.146-.339-.25-.576-.412-.76-.146-.164-.365-.304-.839-.304",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.327 18.52a3.207 3.207 0 1 0 0-6.413 3.207 3.207 0 0 0 0 6.414m0 1a4.207 4.207 0 1 0 0-8.413 4.207 4.207 0 0 0 0 8.414",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.843 13.568a.486.486 0 1 1 .97 0l-.14 2.164h-.692z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.806 16.97a.48.48 0 1 0-.958-.001.48.48 0 0 0 .958 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.122 4.494a3.585 3.585 0 0 0-1.33 6.915l-.372.928a4.586 4.586 0 0 1 1.702-8.843 4.585 4.585 0 0 1 4.246 6.318l-.926-.378a3.585 3.585 0 0 0-3.32-4.94",
    clipRule: "evenodd"
  })));
};
export default SvgIconInEarNotDetected;